/* global axios */
import ApiClient from './ApiClient';

class SupplierCertificatesAPI extends ApiClient {
  constructor() {
    super('suppliers', { accountScoped: true });
  }

  getCertificates(supplierId) {
    return axios.get(`${this.url}/${supplierId}/certificates`);
  }

  create(supplierId, data) {
    const formData = this.buildFormData(data);
    return axios.post(`${this.url}/${supplierId}/certificates`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(supplierId, certificateId, data) {
    const formData = this.buildFormData(data);
    return axios.patch(
      `${this.url}/${supplierId}/certificates/${certificateId}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
  }

  delete(supplierId, certificateId) {
    return axios.delete(
      `${this.url}/${supplierId}/certificates/${certificateId}`
    );
  }

  // eslint-disable-next-line class-methods-use-this
  buildFormData(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      formData.append(`certificate[${key}]`, value);
    });
    return formData;
  }
}

export default new SupplierCertificatesAPI();
